import React from 'react'
import CommonService from '../../services/CommonService'

const PrintPdfComponent = (props) => {
      const { issuanceDetail, drawDetails, contact} = props;

      return (
       <>
        <html>
         <head>
         <meta charset="UTF-8"></meta>
         <style>{"\
          div.repeat-header {\
            padding-top: 0.1in !important;\
            display: block !important;\
            text-align: center;\
            position: running(repeat-header) !important;\
          }\
          .report-header {\
              text-align: center;\
              padding: 5px;\
              width: 100%;\
              height: 40px;\
          }\
          .report-heading-left {\
              font-size: 18px;\
              font-weight: 800;\
              color: darkblue;\
              text-align: left;\
              width: 20%;\
          }\
          .report-heading-center {\
              font-size: 12px;\
              font-weight: 800;\
              color: darkblue;\
              text-align: center;\
              width: 60%;\
          }\
          .report-heading-right {\
              font-size: 12px;\
              font-weight: 800;\
              color: darkblue;\
              text-align: right;\
              width: 20%;\
          }\
          .report-heading-title {\
              font-size: 18px;\
              font-weight: 800;\
              color: darkblue;\
              text-align: left;\
              min-width: 65%;\
          }\
          .report-heading-date {\
              font-size: 10px;\
              font-weight: 800;\
              color: darkblue;\
              text-align: right;\
          }\
          div.footer {\
            position: running(footer) !important;\
          }\
          #current-page-placeholder::before {\
            content: counter(page);\
          }\
          #total-pages-placeholder::before {\
            content: counter(pages);\
          }\
          @page {\
              margin-top: 100px;\
              @top-center {\
                  content: element(repeat-header) !important\
              }\
          }\
          @page {\
              @bottom-right {\
                  content: element(footer) !important;\
                  font-size: 10px;\
              }\
          }\
          div.repeat-header table {\
              page-break-inside: avoid;\
          }\
          div.repeat-header tr {\
              page-break-inside: avoid;\
              page-break-after: auto\
          }\
          div.repeat-header thead {\
              display: table-header-group\
          }\
          div.repeat-header tfoot {\
              display: table-footer-group\
          }\
          div.break-page {\
              page-break-after: always;\
          }\
          .table a {\
              color: black;\
              text-decoration: underline;\
          }\
          .table .tableheader th, .table tbody th {\
              color: #fff;\
              background-color: darkblue;\
              border-color: #454d55;\
              vertical-align: middle;\
              font-size: 1.0em;\
          }\
          .v-top {\
              vertical-align: top !important;\
          }\
          tr {\
              page-break-inside: avoid\
          }\
          .invoice-box{\
            max-width: 800px;\
            margin: auto;\
            padding: 20px;\
            border: 1px solid #eee;\
            box-shadow: 0 0 10px rgba(0, 0, 0, .15);\
            font-size: 13px;\
            line-height: 18px;\
            font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;\
            color: #555;\
          }\
          .invoice-box table {\
            width: 100%;\
            line-height: inherit;\
            text-align: left;\
          }\
          .invoice-box table td {\
            padding: 5px;\
            vertical-align: top;\
          }\
        .border-top {\
              border-top: 2px solid #eee;\
          }\
          .invoice-box table tr.top table td.title {\
              font-size: 13px;\
              line-height: 22px;\
              color: #333;\
          }\
          .invoice-box table tr.information table td {\
              padding-bottom: 10px;\
          }\
          .invoice-box table tr.heading td {\
              border-bottom: 1px solid #ddd;\
              font-weight: bold;\
          }\
          .invoice-box table tr.item td {\
            border-bottom: 1px solid #eee;\
          }\
          .invoice-box table tr.item.last td {\
              border-bottom: none;\
          }\
          .invoice-box table tr.total {\
              border-top: 2px solid #eee;\
              font-weight: bold;\
          }\
          .invoice-box table tr.section-title td {\
            font-weight: bold;\
            font-size: 18px;\
            line-height: 18px;\
            color: #000;\
          }\
          @media only screen and (max-width: 600px) {\
          .invoice-box table tr.top table td {\
              width: 100%;\
              display: block;\
              text-align: center;\
          }\
          .invoice-box table tr.information table td {\
              width: 100%;\
              display: block;\
              text-align: center;\
          }\
          }\
        "}</style>
         </head>
          <body className="pdf-box">
            <div className="invoice-box">
            <table cellPadding="0" cellSpacing="0">
              <tbody><tr className="information">
                <td colSpan="12">
                  <table><tbody>
                    <tr className="section-title"><td>Issuance</td></tr>
                    <tr>
                      <td>
                        <table>
                          <tbody>
                            <tr><td colSpan="8">CDIAC #:</td><td colSpan="4" align="right">{issuanceDetail.cdiacNumber}</td></tr>
                            <tr><td colSpan="8">Issuer Name:</td><td colSpan="4" align="right">{issuanceDetail.issuerName}</td></tr>
                            <tr><td colSpan="8">Issue Name:</td><td colSpan="4" align="right">{issuanceDetail.issueName}</td></tr>
                            <tr><td colSpan="8">Project Name:</td><td colSpan="4" align="right">{issuanceDetail.projectName}</td></tr>
                            <tr><td colSpan="8">Actual Sale Date:</td><td colSpan="4" align="right">{CommonService.dateFormatter(issuanceDetail.actualSaleDate)}</td></tr>
                            <tr><td colSpan="8">Settlement Date:</td><td colSpan="4" align="right">{CommonService.dateFormatter(issuanceDetail.settlementDate)}</td></tr>
                            <tr><td colSpan="8">Principal to be Sold:</td><td colSpan="4" align="right">{CommonService.currencyFormatter(issuanceDetail.principalSaleAmt)}</td></tr>                            
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr className="information">
                <td colSpan="12">
                  <table>
                    <tbody>
                    <tr className="section-title"><td>Event Details</td></tr>
                    <tr>
                      <td>
                        <table>
                          <tbody>
                          <tr><td colSpan="8">Submitted per:</td><td colSpan="4" align="right">{drawDetails.drawCode !== null ? (drawDetails.drawCode === "MLR" ? "Section 53359.5(c) of the California Government Code Mello-Roos Community Facilities Districts Default or Draw on Reserve Reporting." : "Section 6599.1(c) of the California Government Code Marks-Roos Bond Pooling Act Participants Default or Draw on Reserve Reporting.") : ""} </td></tr>
                          <tr><td colSpan="8">Event Type:</td><td colSpan="4" align="right">{drawDetails.drawFlagDescription}</td></tr>
                          <tr><td colSpan="8">Event Date:</td><td colSpan="4" align="right">{CommonService.dateFormatter(drawDetails.drawDate)}</td></tr>
                          <tr><td colSpan="8">Amount:</td><td colSpan="4" align="right">{CommonService.currencyFormatter(drawDetails.drawAmt)}</td></tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              {/* Filing Contact */}
              <tr className="information">
                <td colSpan="12">
                  <table>
                    <tr className="section-title"><td>Filing Contact</td></tr>
                    <tr>
                      <td>
                        <table>
                            <tr><td colSpan="8">Filing Contact Name:</td><td colSpan="4" align="right">{contact.contactFirstName} {contact.contactLastName}</td></tr>
                            <tr><td colSpan="8">Agency/Organization Name:</td><td colSpan="4" align="right">{contact.issuerName}</td></tr>
                            <tr><td colSpan="8">Address:</td><td colSpan="4" align="right">{contact.contactAddressLine1}</td></tr>
                            <tr><td colSpan="8">City:</td><td colSpan="4" align="right">{contact.contactCityName}</td></tr>
                            <tr><td colSpan="8">State:</td><td colSpan="4" align="right">{contact.contactStateCode}</td></tr>
                            <tr><td colSpan="8">Zip Code:</td><td colSpan="4" align="right">{contact.contactZipCode}</td></tr>
                            <tr><td colSpan="8">Telephone:</td><td colSpan="4" align="right">{contact.contactPhoneAreaCode && contact.contactPhoneAreaCode + "-" }{contact.contactPhoneNumber}</td></tr>
                            <tr><td colSpan="8">Fax Number:</td><td colSpan="4" align="right">{contact.contactFaxNumber}</td></tr>
                            <tr><td colSpan="8">E-mail:</td><td colSpan="4" align="right">{contact.contactEmailId}</td></tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr className="information">
                <td colSpan="12">
                  <table>
                    <tr className="section-title"><td>Comments</td></tr>
                    <tr>
                      <td>
                        <table>
                          <tr><td colSpan="8">Issuer Comments:</td><td colSpan="4">{drawDetails.issuerComment}</td></tr>
                          <tr><td colSpan="8">CDIAC Comments:</td><td colSpan="4">{drawDetails.cdiacComment}</td></tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </tbody>
            </table>
            <table>
              <tbody>
              {drawDetails.statusFlag !== 'D' &&
              <tr className="information">
                <td colSpan="8">Submission Date:</td><td colSpan="4" align="right">{CommonService.dateFormatter(drawDetails.filingDate)}</td>
              </tr>
              }
              {drawDetails.statusFlag === 'R' &&
              <tr className="information">
                <td colSpan="8">Review Date:</td><td colSpan="4" align="right">{CommonService.dateFormatter(drawDetails.lastUpdateDatetime)}</td>
              </tr>
              }
              </tbody>
            </table>
           </div>
          </body>
        </html>
       </>
      );
    //}
  }

  export default PrintPdfComponent;